// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"e04e8f61","238":"d1ffe418","490":"618a4337","630":"2be9eaed","682":"d205300f","758":"9d988f9a","787":"c28d1b22","985":"907832b0"}[chunkId] + ".chunk.js";
};